<ng-container *ngIf="formField?.touched">
  <ng-container *ngIf="formField.hasError('required')">
    {{ 'INTL_FORM_ERROR_REQUIRED' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('partnerTypeRequired')">
    {{ 'INTL_PARTNER_TYPE_REQUIRED' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxContentSize')">
    {{
      'INTL_FORM_ERROR_MAX_CONTENT_SIZE'
        | translate
          : {
              maxSize: formField.getError('maxContentSize').maxSize | fileSize,
              actualSize: formField.getError('maxContentSize').actualSize | fileSize
            }
    }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('url')">
    {{ 'INTL_FORM_ERROR_URL' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('matDatepickerParse')">
    {{ 'INTL_FORM_ERROR_DATE_FORMAT' | translate : { format: dateFormat } }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('serverError')">
    {{ formField.errors.serverError.message }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('compare')">
    {{ compareTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('compareToSumTarget')">
    {{ compareToSumTargetTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('divisibleBy')">
    {{ divisibleByTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('minIncrement')">
    {{ minIncrementTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('minCurrencyValue')">
    {{ minCurrencyValueTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxCurrencyValue')">
    {{ maxCurrencyValueTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('dateOfBirth')">
    <ng-container *ngIf="formField.getError('dateOfBirth')?.errorType === 'futureDate'">
      {{ dateOfBirthFutureTranslation }}
    </ng-container>
    <ng-container *ngIf="formField.getError('dateOfBirth')?.errorType === 'tooYoung'">
      {{ dateOfBirthTooYoungTranslation }}
    </ng-container>
    <ng-container *ngIf="formField.getError('dateOfBirth')?.errorType === 'tooOld'">
      {{ dateOfBirthTooOldTranslation }}
    </ng-container>
  </ng-container>

  <ng-container *ngIf="formField.hasError('compareToSumSummand')">
    {{ compareToSumSummandTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('email')">
    {{ 'INTL_FORM_ERROR_EMAIL' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('pattern')">{{
    'INTL_FORM_ERROR_INCORRECT_FORMAT' | translate
  }}</ng-container>

  <ng-container *ngIf="formField.hasError('minlength')">
    {{
      'INTL_FORM_ERROR_MIN_LENGTH'
        | translate
          : {
              requiredLength: formField.getError('minlength').requiredLength,
              actualLength: formField.getError('minlength').actualLength
            }
    }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxlength')">
    {{
      'INTL_FORM_ERROR_MAX_LENGTH'
        | translate
          : {
              requiredLength: formField.getError('maxlength').requiredLength,
              actualLength: formField.getError('maxlength').actualLength
            }
    }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('min')">
    {{ 'INTL_FORM_ERROR_VALUE_MIN' | translate : { min: formField.getError('min').min } }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('max')">
    {{ 'INTL_FORM_ERROR_VALUE_MAX' | translate : { max: formField.getError('max').max } }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('onlyDigits')">
    {{ 'INTL_FORM_ERROR_PASSWORD_JUST_DIGITS' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('password')">
    {{ formField.errors.password.message }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('integer')">
    {{ 'INTL_FORM_ERROR_INTEGER' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('vatin')">
    {{ 'INTL_FORM_ERROR_VATIN' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('lei')">
    {{ 'INTL_FORM_ERROR_LEI' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('nonEmpty')">
    {{ 'INTL_FORM_ERROR_NON_EMPTY' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('domainExists')">
    {{ 'INTL_DOMAIN_ALREADY_EXISTS' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('phone')">
    {{ phoneTranslation }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('beneficialOwnerPercentage')">
    {{ 'INTL_BENEFICIAL_OWNER_MIN_PERCENTAGE_WARNING' | translate }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxInitialInvestmentVolume')">
    {{
      'INTL_FORM_ERROR_MAX_INITIAL_INVESTMENT_VOLUME'
        | translate : { max: formField.getError('maxInitialInvestmentVolume') | number }
    }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxDigits')">
    {{ formField.getError('maxDigits').message }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxDecimalPlaces')">
    {{ formField.getError('maxDecimalPlaces').message }}
  </ng-container>

  <ng-container *ngIf="formField.hasError('maxIntegerDigits')">
    {{ formField.getError('maxIntegerDigits').message }}
  </ng-container>
</ng-container>

<!-- Outside of 'touched' as it should be displayed on initial form load -->
<ng-container *ngIf="formField?.hasError('matDatepickerMin')">
  {{ 'INTL_FORM_ERROR_DATE_MIN' | translate : { minDate: formField.getError('matDatepickerMin').min | waiDate } }}
</ng-container>

<ng-container *ngIf="formField?.hasError('matDatepickerMax')">
  {{ 'INTL_FORM_ERROR_DATE_MAX' | translate : { maxDate: formField.getError('matDatepickerMax').max | waiDate } }}
</ng-container>

<ng-container *ngIf="formField?.hasError('invalidDomain')">
  {{ formField?.getError('invalidDomain').reason }}
</ng-container>

<ng-container *ngIf="formField?.hasError('duplicateDomain')">
  {{ formField?.getError('duplicateDomain').reason }}
</ng-container>

<ng-container *ngIf="formField?.hasError('postalCode')">
  {{ formField?.getError('postalCode').errorKey | translate }}
</ng-container>
